import styled, { css } from 'styled-components';

const Backdrop = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: none;
    justify-content: center;
    align-items: center;
    z-index: 4;

    ${(props) => props.isOpen && css`
        display: flex;
    `}
`;

const ModalWrapper = styled.div`
    position: relative;
    width: ${props => props.$width|| '1000px'};
    height: ${props => props.$height || '500px'};
    background-color: ${(props) => props.theme.colors.highClearGray};
    border-radius: 10px;

`;

const ModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    padding: 30px;
    width: ${props => props.$width|| '940px'};
    height: ${props => props.$height || '400px'};
    background-color: white;
    margin-top: 35px;
    margin-left: 31px;
    border: 1px solid;
    border-color: ${(props) => props.theme.colors.silverGrayTwo};
    overflow: scroll;
`;

const ModalTitle = styled.div`
    font-size: 18px;
    color: ${(props) => props.theme.colors.silverGrayTwo};
`;

const StyledModalSubtitle = styled.p`
    font-size: 20px;
    margin-bottom: 0;
`;

const ModalSubtitle = ({ children }) => <StyledModalSubtitle>{children}</StyledModalSubtitle>;

const ModalContainerCloseButton = styled.div`
    margin-top: 10px;
    margin-left: 820px;
    cursor: pointer;
`;

const ModalCloseButton = styled.button`
    cursor: pointer;
    width: ${props => props.$width|| '150px'};
    height: ${props => props.$height || '40px'};
    border-radius: 8px;
    border: 1px solid black;
`;

export {
    Backdrop,
    ModalWrapper,
    ModalContainer,
    ModalTitle,
    ModalSubtitle,
    ModalCloseButton,
    ModalContainerCloseButton
    
};
